import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const GoogleAuthCallback = () => {
  const history = useHistory();

  useEffect(() => {
    // The callback function just needs to close the window
    // The backend API handles all the token exchange
    window.close();

    // If the window doesn't close (e.g., it wasn't opened as a popup)
    // redirect to account page after 2 seconds
    const timer = setTimeout(() => {
      history.push('/account');
    }, 2000);

    return () => clearTimeout(timer);
  }, [history]);

  return (
    <div style={{ textAlign: 'center', marginTop: '40px' }}>
      <h2>Google Account Connected Successfully</h2>
      <p>This window should close automatically. If it doesn&apos;t, you can close it and return to Chatterbox.</p>
    </div>
  );
};

GoogleAuthCallback.propTypes = {};

export default GoogleAuthCallback;
